import React from 'react';
import PlusIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import './AddButton.css';

const AddButton = ({ click }) => (
  <div className="AddButton" onClick={click}>
    <PlusIcon />
  </div>
);

AddButton.propTypes = {
  click: PropTypes.func.isRequired
};

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/AddButton.js